import { StatisticsItemModel } from './statistics-item.model';

export class ExtendedStatisticsItemModel extends StatisticsItemModel {
    percentage: number;

    constructor(init?: Partial<ExtendedStatisticsItemModel>) {
        super();
        Object.assign(this, init);
    }
}
